import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';

/*
  Generated class for the ImagenesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ImagenesProvider {

  private api: string;
  private usuario;
  constructor(public http: Http, public global: GlobalProvider) {
    this.api = this.global.api;
    // this.usuario = this.global.usuario;
  }

  public convierte(clave, imagen): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "imagen": imagen,
      "clave": clave
    };
   console.log(parametros);
    
    return this.http.post(this.api + "apigen/convierte_imagen.php", parametros, options).map(
      (response) => {
      
        var respuesta = response.json();
     
        return respuesta[0];

      }
    ).catch(this.handleError);
  }
  public convierte2(clave, imagen, id): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "imagen": imagen,
      "id": id,
      "clave": clave
    };
   
    
    return this.http.post(this.api + "apigen/convierte_imagen_origen.php", parametros, options).map(
      (response) => {

        var respuesta = response.json();
      
        return respuesta[0];

      }
    ).catch(this.handleError);
  }
  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/providers/imagenes/imagenes.ts